// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._M_JFHQ84X43ziZn_3Lo{flex-direction:column;display:flex}.F6Pp8SDY_koDv3vrFgpQ{flex-direction:column;gap:16px;margin-top:24px;display:flex}.AeFu5DL4BoMvxXAEnK8P{justify-content:flex-end;gap:8px;padding-top:32px;display:flex}.YFJgD05ychwUJ4ZySgvM{cursor:pointer;border-radius:6px;align-items:center;gap:6px;padding:8px;display:flex}.YFJgD05ychwUJ4ZySgvM:hover{background-color:var(--background-neutral-subtle)}.N9FJ70c6q8c2RsRUu4wV{text-overflow:ellipsis;flex-shrink:1;max-width:256px;display:inline-block;overflow:hidden}.vVQSeGkAt6UfV2a7jKvN{flex-shrink:0}.jjo6XfqnxCoKoBP2WamL{gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `_M_JFHQ84X43ziZn_3Lo`,
	"content": `F6Pp8SDY_koDv3vrFgpQ`,
	"actions": `AeFu5DL4BoMvxXAEnK8P`,
	"wrapPlaceholder": `YFJgD05ychwUJ4ZySgvM`,
	"labelRight": `N9FJ70c6q8c2RsRUu4wV`,
	"labelContent": `vVQSeGkAt6UfV2a7jKvN`,
	"inputPlaceholder": `jjo6XfqnxCoKoBP2WamL`
};
export default ___CSS_LOADER_EXPORT___;
